import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBugcrowdComponent } from './simple-icons-bugcrowd.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBugcrowdComponent ],
    exports:      [ SimpleIconsBugcrowdComponent ],
    bootstrap:    []
})
export class SimpleIconsBugcrowdModule {}
